import React from 'react';
import { connect } from "react-redux";
import {Grid} from "semantic-ui-react";
import VeritasHeader from "../../../shared/VeritasHeader";
import KYBServicesTable from "./KYBServicesTable";
import {fetchKYBServices} from "../../actions/ServicesActions";
import {InlineLoading} from "../../../../common/partials/Loading";
import KYBListSidebarFilters from "./KYBListSidebarFilters";
import Breadcrumb from '../../../../common/partials/Breadcrumb';
import { setBreadCrumb } from '../../../breadcrumb/BreadcrumbActions';
import Sidebar from "../../../../common/components/Sidebar";
import VeritasSidebarButtons from "../../../shared/VeritasSidebarButtons";

export class KYBServicesListPage extends React.Component {

    componentDidMount() {
        document.title = `Veritas - KYB Services`;
        // If the application reloads at this point, make an API call
        // to get all the services so that for a possible navigation
        // directly to the KYC or KYB Services List page, the data is
        // loaded for rendering.  This will also help in refreshing the list
        // if any edits are performed on the detail page.
        this.props.getAllKYBServices();

        this.props.setBreadCrumb({
            parent:  { url: '/veritas', text: 'Veritas' },
            list:    { url: '/veritas/kyb-services', text: 'KYB Services'},
            service: { url: '', text: ''},
            source:  { url: '', text: ''},
        })
    }

    render() {
        return (
            <div className="veritas">
                <VeritasHeader />
                <Grid relaxed={true}>
                    <Grid.Column width={3}>
                        <Sidebar>
                            <VeritasSidebarButtons />
                            <div className="divider-background">
                                <hr />
                            </div>
                            <KYBListSidebarFilters />
                        </Sidebar>
                    </Grid.Column>
                    <Grid.Column width={13}>
                        <Breadcrumb />
                        {this.props.kyb_filtered_state
                            ? (<KYBServicesTable KYBServices={this.props.filtered_kyb_services} />)
                            : (<InlineLoading />)
                        }
                    </Grid.Column>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    kyb_services: state.veritas.kybServices.kyb_services,
    filtered_kyb_services: state.veritas.kybServices.filtered_kyb_services,
    kyb_filtered_state: state.veritas.kybServices.kyb_filtered_state,
});
const mapDispatchToProps = dispatch => ({
    getAllKYBServices: () => {dispatch(fetchKYBServices())},
    setBreadCrumb: (crumb) => {dispatch(setBreadCrumb(crumb))},
});


export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(KYBServicesListPage)
